module.exports = __webpack_public_path__ + "static/assets/7b80fcafc9fc92e3bd91a895acf4ca7a.gif";